export var USERS_MANAGEMENT_PATH = '/users-management/';
export var USERS_LIST_PATH = "".concat(USERS_MANAGEMENT_PATH, "users/");
export var USER_DETAILS_PATH = "".concat(USERS_LIST_PATH, ":id");
export var PERMISSION_GROUPS_PATH = "".concat(USERS_MANAGEMENT_PATH, "permission-groups/");
export var PERMISSION_GROUP_PATH = "".concat(USERS_MANAGEMENT_PATH, "permission-groups/:id");
export var CREATE_USER_PASSWORD_INVITATION_PATH = "/user-invite/:code";
